import { render, staticRenderFns } from "./AsfFormWrapper.vue?vue&type=template&id=408b325a"
import script from "./AsfFormWrapper.vue?vue&type=script&lang=js"
export * from "./AsfFormWrapper.vue?vue&type=script&lang=js"
import style0 from "./AsfFormWrapper.vue?vue&type=style&index=0&id=408b325a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports